import React, { FunctionComponent } from "react"
import { Table, TableBody, TableRow, TableCell, TableContainer, TableHead } from "@material-ui/core"
import { ReportsTableRow } from "./ReportsTableRow"
export interface UserUsageReport {
    id: number
    email: string
    loginCount: number
    translatedAudioCount: number
    generatedAudioCount: number
    approvedAudioCount: number
    uploadedAudioCount: number
}
export interface ReportsTableProps {
    reports: UserUsageReport[]
}

export const ReportsTable: FunctionComponent<ReportsTableProps> = props => {
    const { reports } = props
    return (
        <TableContainer>
            <Table id="reportsTable" data-testid="reports-table">
                <TableHead>
                    <TableRow>
                        <TableCell data-testid="emailCol">Email</TableCell>
                        <TableCell data-testid="loginsCol">Logins</TableCell>
                        <TableCell data-testid="translationsCol">Translations</TableCell>
                        <TableCell data-testid="generatedAudioCol">Generated Audio</TableCell>
                        <TableCell data-testid="audioFilesCol">Approved Audio Files</TableCell>
                        <TableCell data-testid="uploadsCol">Uploads</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {reports.map((report, index) => (
                        <ReportsTableRow key={index} report={report} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
